import { useNavigate } from "react-router-dom";
import moment from "moment";
import { useGetCollectionWardQuery } from "./CollectionWardSlice";
import { useEffect, useState } from "react";
import SpinnerForPage from "../../components/spinner/SpinnerForPage";
import { useGetWardsQuery } from "../wards/wardSlice";


const CollectionWard = () => {
    const {
        data: wards,
        isSuccess,
        isError,
        error
    } = useGetWardsQuery('getWards');

    const [filter, setFIlter] = useState(() => {
        const filters = JSON.parse(localStorage.getItem("collectionWardFilter"));
        if (filters) {
            return filters
        }
        return {}
    });
    const [filterData, setFIlterData] = useState({});
    const navigate = useNavigate()

    useEffect(() => {
        setFIlterData(filter)

    }, [navigate]);


    const [page, setPage] = useState(() => {
        const savedPage = localStorage.getItem('SurveyProperties');
        return savedPage ? Number(savedPage) : 1;
    })

    useEffect(() => {
        localStorage.setItem('SurveyProperties', page);
    }, [page]);

    const pageMin = () => setPage((prev) => Math.max(prev - 1, 1));
    const pageAdd = () => setPage((prev) => Math.min(prev + 1, totalPages));
    const firstPage = () => setPage(1);
    const lastPage = () => setPage(totalPages);

    // // page global state
    // const countPage = useSelector((state) => state.DailyReportdateB2g.page);
    // const dispatch = useDispatch();



    const {
        data: CollectionWard,
        isLoading
    } = useGetCollectionWardQuery({ page, filterData })


    let totalPages = 1;
    if (CollectionWard && Array.isArray(CollectionWard) && CollectionWard.length > 0) {
        totalPages = CollectionWard[0]?.totalPages;
    }

    const searchHandle = (e) => {
        e.preventDefault();
        localStorage.setItem("collectionWardFilter", JSON.stringify({ ...filter, [e.target.name]: e.target.value }));
        setFIlter({ ...filter, [e.target.name]: e.target.value });
    }


    const reset = () => {
        setFIlter({ ward_id: "", startdate: "", enddate: "" })
        setFIlterData({ ward_id: "", startdate: "", enddate: "" })
        localStorage.removeItem("collectionWardFilter")
    }

    return (
        <>
            {isLoading && <SpinnerForPage />}
            <div className="container-fluid mt-5">
                <div className="card card-dark">
                    <div className="mobile-hidden w-100 d-flex justify-content-center gap-5">
                        <select className="district_select form-select " value={filter?.ward_id} name="ward_id" onChange={searchHandle} >
                            <option value="" >Select Ward</option>
                            {wards?.ids?.map((e) => {
                                return <option value={wards?.entities[e]?.ward_id}>{wards?.entities[e]?.ward_number}</option>
                            })}
                        </select>
                        <input className="form-select" value={filter?.startdate} onChange={searchHandle} name="startdate" type="date" placeholder="Search Number" />
                        <input className="form-select" value={filter?.enddate} onChange={searchHandle} name="enddate" type="date" placeholder="Search Number" />
                        <button onClick={() => setFIlterData(filter)} className="bg-left-navabr  text-light  btn btn-secondary" >Search</button>
                        <button onClick={reset} className="bg-left-navabr  text-light  btn btn-secondary" >Reset</button>

                        {/* <button onClick={search} className="bg-left-navabr  text-light  btn btn-secondary" >Search</button> */}

                    </div>
                    <div className="table-border-style">
                        <div className="table-responsive">
                            <table className="table table-striped">
                                <thead>
                                    <tr className="text-left mobile-hidden">
                                        <th scope="col">Date</th>
                                        <th scope="col">Wards</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* length */}
                                    {
                                        CollectionWard && Array.isArray(CollectionWard) && CollectionWard.length > 0 && CollectionWard[0]?.data?.map((e, index) => {
                                            return (
                                                <>
                                                    <tr key={index} className="listData text-left fw-normal" onClick={() => { navigate(`/b2g/CollectionWard_Data/${e?.collection_date}/${e?.ward_id}`) }}>
                                                        <td>{moment(e?.collection_date).format("YYYY-MM-DD").toLocaleString("en-US", { timeZone: "Asia/Calcutta", hour12: true, hour: "numeric", minute: "numeric" })}</td>
                                                        <td>{e?.ward_number}</td>
                                                    </tr>
                                                </>
                                            )

                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className=" row mt-3 mb-3">
                    <div className="col-md-12 d-flex justify-content-center">
                        <div className="pagination">
                            <button className="page-link" onClick={firstPage}>
                                1
                            </button>
                            <button className="page-link" disabled={page <= 1} onClick={pageMin}>
                                &laquo; Previous
                            </button>
                            <div className="page-link">{page}</div>
                            <button className="page-link" disabled={page >= totalPages} onClick={pageAdd}>
                                Next &raquo;
                            </button>
                            <button className="page-link" onClick={lastPage}>
                                {totalPages}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default CollectionWard;